import Vue from "vue";
import { Component } from "vue-property-decorator";
import {
    NotificationMission,
    UserInfos,
} from "@/components";
import { IWorkOrderMission, WorkOrderMissionType } from "@/models";

@Component({
    name: "sidebar-return",
    components: {
        "notification-mission": NotificationMission,
        "user-infos": UserInfos,
    },
})

export default class SidebarReturn extends Vue {
    public collapsed: boolean;

    public get woMissions(): IWorkOrderMission[] {
        let woMissions: IWorkOrderMission[] = [];
        if (this.$route.params.productionLineId) {
            const productionLineId = parseInt(this.$route.params.productionLineId, 10);
            woMissions = this.$store.getters["productionLines/getProductionLineWorkOrderMissions"](productionLineId);
        }
        else if (this.$route.params.workOrderId) {
            const workOrderId = parseInt(this.$route.params.workOrderId, 10);
            const workOrder = this.$store.getters["productionLines/getWorkOrderById"](workOrderId);
            if (workOrder) {
                woMissions = workOrder.workOrderMissions;
            }
        }
        else {
            woMissions = this.$store.getters["productionLines/getWorkOrderMissions"]();
        }
        return woMissions.filter(wom => wom.type === WorkOrderMissionType.Return);
    }

    public get notifications(): string[] {
        return this.$store.state.productionLines.notifications;
    }

    constructor() {
        super();

        this.collapsed = true;
    }

    public toggleCollapsed(): void {
        this.collapsed = this.collapsed ? false : true;
    }

    public deleteNotification(index: number): void {
        this.$store.dispatch("productionLines/deleteNotification", index);
    }
}
